import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import TableLayout from "../../../../components/TableLayout";
// import { getUsers, updateUser } from "../../../store/users/actions";
import {
  getCharRequestList,
  editCharRequest,
} from "../../../../store/characterPublicRequest/actions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import logoicon from "../../../../Assets/images/usericon.png";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
// import { DownloadUserList } from "../../../store/downloadcsv/actions";
const ManageUsers = () => {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const { list, loading, totalCount } = useSelector(
    (state) => state.CharacterPublicRequest
  );
  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [filter, setFilter] = useState({
    status: "pending",
    pageNo: 1,
    limit: pageSize,
    // search: "",
  });
  const fetchData = async () => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          // toast.success(res.message);
        }
      };
      dispatch(getCharRequestList({ data: filter, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    fetchData();
  }, [filter]);

  useEffect(() => {
    if (selectedStatus !== filter.status) {
      setFilter((prev) => ({
        ...prev,
        status: selectedStatus,
      }));
    }
  }, [selectedStatus]);

  const handleUserStatus = (item) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData();
          toast.success(res.message);
        }
      };
      dispatch(
        editCharRequest({
          data: {
            response: item.status,
            // characterId: item?.character?._id,
            requestId: item._id,
          },
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<=== Error occurred");
    }
  };
  const handlePageChange = (page) => {
    setFilter((prev) => ({ ...prev, pageNo: page.selected + 1 }));
  };
  const handleFilter = () => {
    setFilter((prev) => ({
      ...prev,
      status: selectedStatus,
    }));
  };
  const clearFilter = () => {
    setFilter({ pageNo: 1, limit: pageSize });
    setSelectedStatus("");
  };

  const handleViewUser = (id) => {
    navigate(`/make-character-public/${id}`);
  };

  const column = [
    {
      head: "Sr No",
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span className="text-capitalize cursor-pointer">
          {(filter.pageNo - 1) * pageSize + (ind + 1)}
        </span>
      ),
    },
    {
      head: "Name",
      accessor: "userName",
      isComponent: true,
      component: (item, key) => {
        return (
          <>
            <div className="content">
              <p className="m-0 text-muted text-capitalize">
                {item?.user?.userName}
              </p>
            </div>
          </>
        );
      },
    },
    {
      head: "Email Address ",
      accessor: "email",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">{item?.user?.email}</span>
      ),
    },
    {
      head: "Character Name",
      accessor: "character name",
      isComponent: true,
      component: (item, ind) => (
        <>
          <div className="d-flex align-items-center gap-10">
            <div className="imgWrp flex-shrink-0">
              {item?.character?.image ? (
                <img
                  src={item?.character?.image}
                  alt=""
                  style={{ height: 30, width: 30 }}
                  className="img-fluid object-fit-cover rounded-circle"
                />
              ) : (
                <img
                  src={logoicon}
                  alt=""
                  style={{ height: 30, width: 30 }}
                  className="img-fluid object-fit-cover rounded-circle"
                />
              )}
            </div>
            <div className="content">
              <p className="m-0 text-muted text-capitalize">
                {item?.character?.name}
              </p>
            </div>
          </div>
        </>
      ),
    },
    {
      head: "Character Age",
      accessor: "character age",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">{item?.character?.age}</span>
      ),
    },
    {
      head: "Character Created At",
      accessor: "createdAt",
      isComponent: true,
      component: (item, ind) => (
        <span className="text">
          {moment(item?.character?.createdAt).format("YYYY-MM-DD")}
        </span>
      ),
    },
    {
      head: "Status",
      accessor: "Status",
      isComponent: true,
      component: (item, ind) => (
        <p
          className={`${
            item.response == "pending"
              ? "yellowStatus"
              : item.response == "rejected"
              ? "redStatus"
              : item.response == "approved"
              ? "greenStatus"
              : ""
          } status text-capitalize m-0 d-flex justify-content-center align-item-center rounded-pill px-3 py-1`}
        >
          {item.response}
        </p>
      ),
    },
    {
      head: "Actions",
      accessor: "",
      isComponent: true,
      component: (item) => {
        const isFinalStatus =
          item.response === "approved" || item.response === "rejected";

        return (
          <div className="ActnBtn d-flex align-items-center gap-10">
            <div className="d-flex gap-2">
              <Button
                variant="outline-primary"
                size="sm"
                disabled={isFinalStatus}
                onClick={() =>
                  handleUserStatus({ ...item, status: "approved" })
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.485 1.929a.75.75 0 0 1 1.06 1.06l-8 8a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L6 9.44l7.485-7.51z" />
                </svg>
              </Button>
              <Button
                variant="outline-primary"
                size="sm"
                disabled={isFinalStatus}
                onClick={() =>
                  handleUserStatus({ ...item, status: "rejected" })
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </Button>
            </div>

            <Button
              onClick={() => handleViewUser(item.characterId)}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5Z"
                  fill="#6F6F6F"
                />
              </svg>
            </Button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="ManageTeacher position-relative">
        <Container>
          <div className="pb-2 cardCstm">
            <Row className="px-3 py-2 bg-white align-items-center">
              <Col lg="12" className="my-2 px-0">
                <div className="px-3 d-flex align-items-center justify-content-between gap-10">
                  <h5 className="mb-0 py-3 fw-sbold text-capitalize px-3">
                    Public Character Request
                  </h5>
                </div>
              </Col>
              {/* <Col md={4} className="mb-3">
                <Form.Control
                  type="text"
                  name="search"
                  value={filter.search || ""}
                  placeholder="Search using name or email"
                  onChange={(e) =>
                    setFilter((prev) => ({ ...prev, search: e.target.value }))
                  }
                />
              </Col> */}
              <Col md={3} className="mb-3">
                <Form.Select
                  className="p-2"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </Form.Select>
              </Col>
              {/* <Col md={3} className="mb-3">
                <div className="d-flex gap-2">
                  <Button onClick={handleFilter} variant="primary">
                    Filter
                  </Button>
                  <Button onClick={clearFilter} variant="secondary">
                    Clear
                  </Button>
                </div>
              </Col> */}
            </Row>
          </div>
          <Row>
            {!loading && (
              <Col lg="12" className=" mx-0">
                <div className="cardCstm p-3 rounded bg-white">
                  {!loading && list?.length > 0 ? (
                    <>
                      <TableLayout
                        data={list}
                        column={column}
                        totalCount={totalCount}
                        limit={filter.limit}
                        loading={loading}
                        handlePageChange={handlePageChange}
                        pageNo={filter.pageNo}
                        status={"status"}
                      />
                    </>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <p>No Data Found</p>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageUsers;
